import { render, staticRenderFns } from "./dynamic-form.vue?vue&type=template&id=afebf2dc&"
import script from "./dynamic-form.vue?vue&type=script&lang=ts&"
export * from "./dynamic-form.vue?vue&type=script&lang=ts&"
import style0 from "./dynamic-form.vue?vue&type=style&index=0&id=afebf2dc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports